import { useQuery } from "@tanstack/react-query";
import { ORGANIZATION_KEYS } from "./queryKeys";
import { getRebuildAPI } from "@rebuild/shared/api";

const { carrierControllerList } = getRebuildAPI();

export function useGetCarriersQuery() {
  return useQuery({
    queryKey: ORGANIZATION_KEYS.carriers(),
    queryFn: async () => {
      const { data } = await carrierControllerList();
      return data ?? [];
    },
  });
}
